<template>
    <div id="shortlistPage">
        <div class="contentBox">
            <p>征稿活动结果管理</p>
            <div class="contentFormBox">
                <!-- 上方按钮 -->
                <div>
                    <el-button
                    type="text"
                    size="small"
                    icon="el-icon-plus"
                    @click="firstCreate()"
                    >新建</el-button
                    >
                    <el-button
                    type="text"
                    size="small"
                    icon="el-icon-edit"
                    @click="preCheck('toEdit')"
                    >编辑</el-button
                    >
                    <el-button
                    type="text"
                    size="small"
                    icon="el-icon-close"
                    @click="preCheck('toDelete')"
                    >删除</el-button
                    >
                    
                    <el-button
                        type="text"
                        icon="el-icon-unlock"
                        size="small"
                        @click="preCheck('toOn')"
                        >启用</el-button
                    >
                    <el-button
                        type="text"
                        icon="el-icon-lock"
                        size="small"
                        @click="preCheck('toOff')"
                        >禁用</el-button
                    >
                    <el-button
                        type="text"
                        icon="el-icon-setting"
                        size="small"
                        @click="preCheck('toSubmitList')"
                        >入选申报列表维护</el-button
                    >
                </div>
                
                <!-- 搜索 -->
                <div class="search-box clearfix">
                    <el-form ref="searchFileForm" :model="searchFileForm" label-width="80px">
                    <el-form-item label="活动名称:">
                        <el-input
                        v-model="searchFileForm.actName"
                        placeholder="请输入活动名称"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="别名">
                        <el-input
                        v-model="searchFileForm.alias"
                        placeholder="请输入别名"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="开始时间">
                        <el-date-picker
                        v-model="searchFileForm.startTime"
                        type="date"
                        placeholder="选择开始日期"
                        format="yyyy 年 MM 月 dd 日"
                        value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="结束时间">
                        <el-date-picker
                        v-model="searchFileForm.endTime"
                        type="date"
                        placeholder="选择结束日期"
                        format="yyyy 年 MM 月 dd 日"
                        value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label-width="0px" style="float: right;text-align: right;">
                        <el-button
                        type="primary"
                        size="mini"
                        icon="el-icon-search"
                        @click="
                            currentPage = 1;
                            onSearch();
                        "
                        >查询</el-button
                        >
                    </el-form-item>
                    </el-form>
                </div>

                <!-- 主列表 -->
                <el-table
                    :data="actResultListData"
                    v-loading="tableLoading"
                    element-loading-text="拼命加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-customClass="loadingStyles"
                    style="width: 100%"
                    class="maintable"
                    border
                    :header-cell-style="{ background: '#f8f8f8' }"
                    @selection-change="handleTableSelectionChange"
                >
                    <el-table-column
                    type="selection"
                    min-width="55"
                    align="center"
                    ></el-table-column>
                    <el-table-column type="index" min-width="50" align="center">
                    </el-table-column>
                    <el-table-column
                    prop="actname"
                    min-width="80"
                    label="活动名称"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="name"
                    min-width="80"
                    label="活动结果标题"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="startTime"
                    show-overflow-tooltip
                    label="开始时间"
                    min-width="70px"
                    align="center"
                    >
                    </el-table-column
                    >
                    <el-table-column
                    prop="endTime"
                    show-overflow-tooltip
                    label="结束时间"
                    min-width="70px"
                    align="center"
                    >
                    </el-table-column
                    >
                    <el-table-column
                    prop="status"
                    show-overflow-tooltip
                    label="活动状态"
                    min-width="70px"
                    align="center"
                    >
                    <template slot-scope="scope">
                        <span effect="dark" v-if="scope.row.status == 20"
                        >启用</span>
                        <span effect="dark" v-if="scope.row.status == 10"
                        >禁用</span>
                    </template>
                    </el-table-column>
                    <el-table-column
                    prop="organizer"
                    show-overflow-tooltip
                    label="主办单位"
                    min-width="70px"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="addUser"
                    show-overflow-tooltip
                    label="创建人"
                    min-width="70px"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="actType"
                    show-overflow-tooltip
                    label="活动类型"
                    min-width="70px"
                    align="center"
                    >
                    <template slot-scope="scope">
                        <span effect="dark" v-if="scope.row.actType == 20"
                        >线下</span>
                        <span effect="dark" v-if="scope.row.actType == 10"
                        >线上</span>
                    </template>
                    </el-table-column>
                    <el-table-column
                    prop="remark"
                    show-overflow-tooltip
                    label="备注"
                    min-width="70px"
                    align="center"
                    >
                    </el-table-column>
                </el-table>
                <!-- 主列表分页 -->
                <div class="pagination-box">
                    <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalSize"
                    >
                    </el-pagination>
                </div>
            </div>

            
            <!-- 新增活动结果弹窗 -->
            <el-dialog
                title="新增活动结果"
                :visible.sync="createDialog"
                width="800px"
            >
                <el-form
                    ref="addActResultForm"
                    :rules="addActResultRules"
                    :model="addActResultForm"
                    label-width="100px"
                >
                    <el-form-item label="活动名称:">
                        <el-select
                            v-model="addActResultForm.actId"
                            style="width: 100%"
                            clearable
                            placeholder="请选择要添加结果的活动。"
                        >
                            <el-option
                                v-for="item in actListData"
                                :key="item.id"
                                :label="item.actName"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="活动结果标题:">
                        <el-input
                            v-model="addActResultForm.name"
                            placeholder="请输入活动结果标题"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="活动结果简介:">
                        <el-input
                            type="textarea"
                            v-model="addActResultForm.introduction"
                            :rows="3"
                            placeholder="请输入活动结果简介"
                        ></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="createAct('addActResultForm')"
                    >确 定
                    </el-button>
                    <el-button @click="createDialog = false">取 消</el-button>
                </span>
            </el-dialog>

            <!-- 编辑活动结果弹窗 -->
            <el-dialog
            title="编辑组织结果活动"
            :visible.sync="editDialog"
            width="800px"
            center
            >
                <el-form
                    ref="editActResultForm"
                    :rules="editActResultRules"
                    :model="editActResultForm"
                    label-width="100px"
                >
                    <el-form-item label="活动名称:">
                        <el-select
                            v-model="editActResultForm.actId"
                            style="width: 100%"
                            clearable
                            placeholder="请选择要添加结果的活动。"
                        >
                            <el-option
                                v-for="item in actListData"
                                :key="item.id"
                                :label="item.actName"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="活动结果标题:">
                        <el-input
                            v-model="editActResultForm.name"
                            placeholder="请输入活动结果标题"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="活动结果简介:">
                        <el-input
                            type="textarea"
                            v-model="editActResultForm.introduction"
                            :rows="3"
                            placeholder="请输入活动结果简介"
                        ></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="updateAct('addActResultForm')"
                    >确 定
                    </el-button>
                    <el-button @click="createDialog = false">取 消</el-button>
                </span>
            </el-dialog>

            <!-- 删除活动结果弹窗 -->
            <el-dialog title="删除活动结果" :visible.sync="deleteDialog" width="30%" center>
                <div>确定删除该活动结果？</div>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="onDelete">确 定</el-button>
                    <el-button @click="deleteDialog = false">取 消</el-button>
                </span>
            </el-dialog>

            <!-- 所有入选申请列表弹窗 -->
            <el-dialog title="所有入选申请列表" :visible.sync="getSubmitAllDialog" width="800px" center>
                <!-- 所有入选申报列表搜索 -->
                <div class="search-box clearfix">
                    <el-form ref="submitAllSearchFileForm" :model="submitAllSearchFileForm" label-width="80px">
                        <el-form-item label="活动名称:">
                            <el-input
                            v-model="submitAllSearchFileForm.actName"
                            placeholder="请输入活动名称"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="标记:">
                            <el-input
                            v-model="submitAllSearchFileForm.mark"
                            placeholder="请输入标记"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label-width="0px" style="float: right;text-align: right;">
                            <el-button
                            type="primary"
                            size="mini"
                            icon="el-icon-search"
                            @click="
                                submitAllCurrentPage = 1;
                                submitAllOnSearch();
                            "
                            >查询</el-button
                            >
                        </el-form-item>
                    </el-form>
                </div>
                <!-- 所有入选申报列表 -->
                <el-table
                    :data="submitAllListData"
                    style="width: 100%"
                    class="maintable"
                    border
                    :header-cell-style="{ background: '#f8f8f8' }"
                    @selection-change="submitAllHandleTableSelectionChange"
                >
                    <el-table-column
                        type="selection"
                        min-width="55"
                        align="center"
                    ></el-table-column>
                    
                    <el-table-column
                        prop="actName"
                        min-width="80"
                        label="征稿活动名称"
                        align="center"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="series"
                        show-overflow-tooltip
                        label="所属系列"
                        min-width="70px"
                        align="center"
                    >
                    <template slot-scope="scope">
                        <span effect="dark" v-if="scope.row.status == '人文社科系列'"
                        >人文社科系列</span>
                        <span effect="dark" v-if="scope.row.status == '科学技术系列'"
                        >科学技术系列</span>
                    </template>
                    </el-table-column
                    >
                    <el-table-column
                        prop="subject"
                        show-overflow-tooltip
                        label="所属学科"
                        min-width="70px"
                        align="center"
                    >
                    </el-table-column
                    >
                    <el-table-column
                        prop="name"
                        show-overflow-tooltip
                        label="成果名称"
                        min-width="70px"
                        align="center"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="applyName"
                        show-overflow-tooltip
                        label="申请人"
                        min-width="70px"
                        align="center"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="workUnit"
                        show-overflow-tooltip
                        label="所在单位"
                        min-width="70px"
                        align="center"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="addTime"
                        show-overflow-tooltip
                        label="提交日期"
                        min-width="70px"
                        align="center"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="mark"
                        show-overflow-tooltip
                        label="标记"
                        min-width="70px"
                        align="center"
                    >
                    </el-table-column>
                </el-table>
                <!-- 所有入选申报列表分页 -->
                <div class="pagination-box">
                    <el-pagination
                    @size-change="submitAllHandleSizeChange"
                    @current-change="submitAllHandleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="submitAllPageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="submitAllTotalSize"
                    >
                    </el-pagination>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="submitListCheck()">确 定</el-button>
                    <el-button @click="getSubmitAllDialog = false">取 消</el-button>
                </span>
            </el-dialog>


            <!-- 维护入选申请列表弹窗 -->
            <el-dialog title="入选申请列表维护" :visible.sync="getCurrentSubmitDialog" width="800px" center>
                <!-- 入选申报列表搜索 -->
                <div class="search-box clearfix">
                    <el-form ref="submitAllSearchFileForm" :model="submitAllSearchFileForm" label-width="80px">
                        <el-form-item label="活动名称:">
                            <el-input
                            v-model="submitAllSearchFileForm.actName"
                            placeholder="请输入活动名称"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="标记:">
                            <el-input
                            v-model="submitAllSearchFileForm.mark"
                            placeholder="请输入标记"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label-width="0px" style="float: right;text-align: right;">
                            <el-button
                            type="primary"
                            size="mini"
                            icon="el-icon-search"
                            @click="
                                submitAllCurrentPage = 1;
                                submitAllOnSearch();
                            "
                            >查询</el-button
                            >
                        </el-form-item>
                    </el-form>
                </div>
                <el-button style="margin-bottom: 10px;" @click="getSubmitAllDialog = true;getAllSubmitList()">添加入选申报</el-button>
                <el-button style="margin-bottom: 10px;" @click="onSubmitDelete()">删除入选申报</el-button>
                <!-- 入选结果列表 -->
                <el-table
                    :data="submitListData"
                    style="width: 100%"
                    class="maintable"
                    border
                    :header-cell-style="{ background: '#f8f8f8' }"
                    @selection-change="submitHandleTableSelectionChange"
                >
                    <el-table-column
                    type="selection"
                    min-width="55"
                    align="center"
                    ></el-table-column>
                    <el-table-column type="index" min-width="50" align="center">
                    </el-table-column>
                    <el-table-column
                    prop="series"
                    show-overflow-tooltip
                    label="所属系列"
                    min-width="70px"
                    align="center"
                    >
                    <template slot-scope="scope">
                        <span effect="dark" v-if="scope.row.series == '人文社科系列'"
                        >人文社科系列</span>
                        <span effect="dark" v-if="scope.row.series == '科学技术系列'"
                        >科学技术系列</span>
                    </template>
                    </el-table-column>
                    <el-table-column
                    prop="actname"
                    min-width="80"
                    label="成果名称"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="addUser"
                    show-overflow-tooltip
                    label="申请人"
                    min-width="70px"
                    align="center"
                    >
                    </el-table-column>
                </el-table>
                <!-- 主列表分页 -->
                <div class="pagination-box">
                    <el-pagination
                    @size-change="submitHandleSizeChange"
                    @current-change="submitHandleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="submitPageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="submitTotalSize"
                    >
                    </el-pagination>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="getSubmitAllDialog = false">确 定</el-button>
                    <el-button @click="getSubmitAllDialog = false">取 消</el-button>
                </span>
            </el-dialog>
        </div>  
    </div>
</template>

<script>
  import '@/assets/css/index.css';
  import $ from 'jquery'; 
  
  export default {
    data() {
      return {
        actResultListData:[],
        tableLoading: false,
        submitAllMultipleSelectionTable: [],
        submitMultipleSelectionTable: [],
        multipleSelectionTable: [],
        submitAllCurrentPage: 1,
        submitAllPageSize: 10,
        submitAllTotalSize: 50,
        submitCurrentPage: 1,
        submitPageSize: 10,
        submitTotalSize: 0,
        currentPage: 1,
        pageSize: 10,
        totalSize: 50,
        userData:"",
        addActResultForm: {},
        editActResultForm: {},
        searchFileForm:{},
        addTime:"",
        editTime:"",
        currentSubmitId:"",
        actListData:[],
        submitListData:[],
        submitAllListData:[],
        submitAllSearchFileForm: {},
        addActResultRules: {},
        editActResultRules: {},
        // 弹窗
        createDialog: false,
        editDialog: false,
        deleteDialog: false,
        getSubmitAllDialog:false,
        getCurrentSubmitDialog:false,
      };
    },
    mounted() {
        this.searchParam();
        this.getActList();
    },
    methods: {
        // 搜索
        onSearch() {
            this.searchParam();
        },
        // 搜索
        submitAllOnSearch() {
            this.searchParam();
        },
        // 加载数据
        searchParam() {
            let that = this;
            // let params = {};
            let params = Object.assign({}, this.searchFileForm);
            params.size = this.pageSize;
            params.page = this.currentPage;
            //   that.tableLoading = true;
            $.ajax({
                type: "GET",
                dataType: "json",
                url: "/zxzg/api/vh/common/act/actResult/list",
                data: params,
                // contentType: "application/json;charset=utf-8",
                success: function (response) {
                if (response.code == 200) {
                    if (response.obj.list && response.obj.list.length == 0) {
                    that.dataText = "暂无数据";
                    }
                    that.totalSize = response.obj.total;
                    that.actResultListData = response.obj.list;
                    that.currentPage = response.obj.pageNum;
                } else {
                    that.$message({
                    message: response.msg,
                    duration: 0,
                    showClose: true,
                    type: "error",
                    offset: 100,
                    });
                }
                },
                error: function (data) {
                    console.log(data);
                },
            });
        },

        // 获取活动列表
        getActList(){
            let that = this;
            $.ajax({
                type: "GET",
                dataType: "json",
                url: "/zxzg/api/vh/common/act/actInfo/list",
                data: { page:1, size:1000 },
                // contentType: "application/json;charset=utf-8",
                success: function (response) {
                if (response.code == 200) {
                    if (response.obj.list && response.obj.list.length == 0) {
                        that.dataText = "暂无数据";
                    }
                    that.actListData = response.obj.list;
                } else {
                    that.$message({
                    message: response.msg,
                    duration: 0,
                    showClose: true,
                    type: "error",
                    offset: 100,
                    });
                }
                },
                error: function (data) {
                console.log(data);
                },
            });
        },

        // 显示新增弹框
        firstCreate() {
            this.addActResultForm = {};
            this.createDialog = true;
        },
            
        // 新增组活动
        createAct(formName) {
            this.addActResultForm.startTime = this.addTime[0];
            this.addActResultForm.endTime = this.addTime[1];
            this.$refs[formName].validate((valid) => {
                if (valid) {
                let that = this;
                $.ajax({
                    url: "/zxzg/api/vh/common/act/actResult/add",
                    type: "POST",
                    dataType: "json",
                    data: this.addActResultForm,
                    error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.reload();
                    }
                    },
                    success: function (data) {
                        if (data.code == 200) {
                            that.$message({
                            message: "新增成功",
                            duration: 2000,
                            showClose: true,
                            type: "success",
                            offset: 100,
                            });
                            that.searchParam();
                            that.createDialog = false;
                        } else {
                            that.$message({
                            message: data.msg,
                            duration: 0,
                            showClose: true,
                            type: "error",
                            offset: 100,
                            });
                        }
                    },
                });
                }
            });
        },

        
        // 编辑活动
        editAct(row) {
            this.editActResultForm = {
                actId: row[0].actId,
                name: row[0].name,
                actResult: row[0].actResult,
            };
            this.editDialog = true;
        },

        // 确认修改
        updateAct(formName) {
            let that = this;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                $.ajax({
                    url: "/zxzg/api/vh/common/act/actResult/update",
                    type: "POST",
                    dataType: "json",
                    data: this.editActResultForm,
                    error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.reload();
                    }
                    },
                    success: function (data) {
                    if (data.code == 200) {
                        that.$message({
                        message: "修改成功",
                        duration: 2000,
                        showClose: true,
                        type: "success",
                        offset: 100,
                        });
                        that.searchParam();
                        that.editDialog = false;
                    } else {
                        that.$message({
                        message: data.msg,
                        duration: 0,
                        showClose: true,
                        type: "error",
                        offset: 100,
                        });
                    }
                    },
                });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },

        // 点击编辑获取当前结果对应的入选申请列表
        updateActResultSubmitList(){
            let that = this;
            let params = Object.assign({}, this.searchFileForm);
            params.size = this.submitPageSize;
            params.page = this.submitCurrentPage;
            params.resultId = this.currentSubmitId;
            $.ajax({
                type: "GET",
                dataType: "json",
                url: "/zxzg/api/vh/common/act/actInfo/list",
                data: params,
                // contentType: "application/json;charset=utf-8",
                success: function (response) {
                if (response.code == 200) {
                    if (response.obj.list && response.obj.list.length == 0) {
                        that.dataText = "暂无数据";
                    }
                    that.submitTotalSize = response.obj.total;
                    that.submitListData = response.obj.list;
                    that.submitCurrentPage = response.obj.pageNum;
                } else {
                    that.$message({
                    message: response.msg,
                    duration: 0,
                    showClose: true,
                    type: "error",
                    offset: 100,
                    });
                }
                },
                error: function (data) {
                console.log(data);
                },
            });
        },
        
        // 编辑、删除、转正式前确认
        preCheck(current) {
            let that = this;
            let ids = this.multipleSelectionTable.map((item) => {
                return item.id;
            });
            if (this.multipleSelectionTable.length == 0) {
                this.$message({
                message: "请选中具体的活动",
                duration: 0,
                showClose: true,
                type: "error",
                offset: 100,
                });
            } else if (current == "toEdit") {
                // 编辑确认
                if (this.multipleSelectionTable.length == 1) {
                    this.editAct(this.multipleSelectionTable);
                } else {
                this.$message({
                    message: "请勿选择多个进行编辑",
                    duration: 0,
                    showClose: true,
                    type: "error",
                    offset: 100,
                });
                }
            } else if (current == "toSubmitList") {// 维护入选申报列表
                if (this.multipleSelectionTable.length == 1) {
                    this.currentSubmitId = this.multipleSelectionTable[0].id;
                    this.updateActResultSubmitList();
                    this.getCurrentSubmitDialog = true;
                } else {
                this.$message({
                    message: "请勿选择多个进行列表维护",
                    duration: 0,
                    showClose: true,
                    type: "error",
                    offset: 100,
                });
                }
            } else if (current == "toDelete") {
                // 删除确认
                let flag = this.multipleSelectionTable.every(function (value) {
                if (value.status == 10) {
                    return true;
                }
                });
                if (flag) {
                    this.deleteDialog = true;
                } else {
                    this.$message({
                        message: "当前有活动非禁用状态，请禁用后再进行删除操作",
                        duration: 0,
                        showClose: true,
                        type: "error",
                        offset: 100,
                    });
                }
            } else if (current == "toOn") {
                $.ajax({
                    url: "/zxzg/api/vh/actResult/enable",
                    type: "POST",
                    //contentType: 'application/json;charset=utf-8',
                    dataType: "json",
                    data: { ids: ids.toString(), flag: 'Y' },
                    error: function (xhr) {
                    this.onclick = true;
                    if (xhr.status == 401) {
                        window.location.reload();
                    }
                    },
                    success: function () {
                        that.$message({
                            message: "启用成功",
                            duration: 2000,
                            showClose: true,
                            type: "success",
                            offset: 100,
                        });
                        that.searchParam();
                    },
                });
            } else if (current == "toOff") {
                $.ajax({
                    url: "/zxzg/api/vh/actResult/enable",
                    type: "POST",
                    //contentType: 'application/json;charset=utf-8',
                    dataType: "json",
                    data: { ids: ids.toString(), flag: 'N' },
                    error: function (xhr) {
                    this.onclick = true;
                    if (xhr.status == 401) {
                        window.location.reload();
                    }
                    },
                    success: function () {
                        that.$message({
                            message: "禁用成功",
                            duration: 2000,
                            showClose: true,
                            type: "success",
                            offset: 100,
                        });
                        that.searchParam();
                    },
                });
            }
        },
        
        // 删除
        onDelete() {
            let ids = this.multipleSelectionTable.map((item) => {
                return item.id;
            });
            let that = this;
            $.ajax({
                url: "/zxzg/api/vh/common/act/actResult/remove",
                type: "POST",
                //contentType: 'application/json;charset=utf-8',
                dataType: "json",
                data: { ids: ids.toString() },
                error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.reload();
                }
                },
                success: function (data) {
                    if (data.code == 200) {
                        that.$message({
                            message: "删除成功",
                            duration: 2000,
                            showClose: true,
                            type: "success",
                            offset: 100,
                        });
                        that.searchParam();
                        that.deleteDialog = false;
                    } else {
                        that.$message({
                            message: data.msg,
                            duration: 0,
                            showClose: true,
                            type: "error",
                            offset: 100,
                        });
                    }
                },
            });
        },
        // 分页
        handleSizeChange(val) {
            this.pageSize = val;
            this.searchParam();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.searchParam();
        },
        // 分页
        submitHandleSizeChange(val) {
            this.pageSize = val;
            this.searchParam();
        },
        submitHandleCurrentChange(val) {
            this.currentPage = val;
            this.searchParam();
        },
        // 分页
        submitAllHandleSizeChange(val) {
            this.pageSize = val;
            this.searchParam();
        },
        submitAllHandleCurrentChange(val) {
            this.currentPage = val;
            this.searchParam();
        },
        
        // 选择表格某一行
        handleTableSelectionChange(val) {
            this.multipleSelectionTable = val;
        },
        
        // 选择表格某一行
        submitAllHandleTableSelectionChange(val) {
            this.submitMultipleSelectionTable = val;
        },
        
        // 选择表格某一行
        submitHandleTableSelectionChange(val) {
            this.submitAllMultipleSelectionTable = val;
        },

        // 获取活动结果对应的入选情况列表
        getAllSubmitList(){
            let that = this;
            let params = Object.assign({}, this.submitAllSearchFileForm);
            params.size = this.submitAllPageSize;
            params.page = this.submitAllCurrentPage;
            params.status = '40';
            $.ajax({
                type: "GET",
                dataType: "json",
                url: "/zxzg/api/vh/common/act/submitInfo/list",
                data: params,
                // contentType: "application/json;charset=utf-8",
                success: function (response) {
                if (response.code == 200) {
                    if (response.obj.list && response.obj.list.length == 0) {
                        that.dataText = "暂无数据";
                    }
                    that.submitAllTotalSize = response.obj.total;
                    that.submitAllListData = response.obj.list;
                    that.submitAllCurrentPage = response.obj.pageNum;
                } else {
                    that.$message({
                    message: response.msg,
                    duration: 0,
                    showClose: true,
                    type: "error",
                    offset: 100,
                    });
                }
                },
                error: function (data) {
                    console.log(data);
                },
            });
        },
        // 添加入选
        submitListCheck(){
            let ids = this.submitMultipleSelectionTable.map((item) => {
                return item.id;
            });
            let that = this;
            $.ajax({
                url: "/zxzg/api/vh/common/act/resultSubmit/remove",
                type: "POST",
                //contentType: 'application/json;charset=utf-8',
                dataType: "json",
                data: { 
                    ids: ids.toString(),
                    id : this.currentSubmitId
                 },
                error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.reload();
                }
                },
                success: function (data) {
                    if (data.code == 200) {
                        that.$message({
                            message: "删除成功",
                            duration: 2000,
                            showClose: true,
                            type: "success",
                            offset: 100,
                        });
                        that.searchParam();
                        that.deleteDialog = false;
                    } else {
                        that.$message({
                            message: data.msg,
                            duration: 0,
                            showClose: true,
                            type: "error",
                            offset: 100,
                        });
                    }
                },
            });
        },

        // 删除入选
        onSubmitDelete() {
            let ids = this.multipleSelectionTable.map((item) => {
                return item.id;
            });
            let that = this;
            $.ajax({
                url: "/zxzg/api/vh/common/act/actResult/remove",
                type: "POST",
                //contentType: 'application/json;charset=utf-8',
                dataType: "json",
                data: { ids: ids.toString() },
                error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.reload();
                }
                },
                success: function (data) {
                    if (data.code == 200) {
                        that.$message({
                            message: "删除成功",
                            duration: 2000,
                            showClose: true,
                            type: "success",
                            offset: 100,
                        });
                        that.searchParam();
                        that.deleteDialog = false;
                    } else {
                        that.$message({
                            message: data.msg,
                            duration: 0,
                            showClose: true,
                            type: "error",
                            offset: 100,
                        });
                    }
                },
            });
        },
    }
  }
</script>

<style scoped>
button.el-button--text {
    background-color: transparent;
    border-color: transparent;
    color: #4c5d65;
    font-size: 14px;
    font-weight: 700;
    padding-left: 8px;
    padding-right: 8px;
    border-radius: 5px;
}

.search-box .el-form-item {
    width:33%;
    float:left;
}

.el-date-editor.el-input, .el-date-editor.el-input__inner{
    width:100%;
}

</style>